export const openPopUp = (url: string, w = 900, h = 900) => {
  const y = (window?.top?.outerHeight || 0) / 2 + (window?.top?.screenY || 0) - h / 2;
  const x = (window?.top?.outerWidth || 0) / 2 + (window?.top?.screenX || 0) - w / 2;
  const newWindow = window.open(
    url,
    'popup',
    'toolbar=no, location=no, directories=no, status=no, menubar=no, copyhistory=no, width=' +
      w +
      ', height=' +
      h +
      ', top=' +
      y +
      ', left=' +
      x,
  );

  if (newWindow && newWindow.focus) {
    newWindow.focus();
  }
};
